module.exports = __webpack_public_path__ + "img/2025.bbf40c1c.jpg";